import React from 'react';
import TitleBase from './TitleBase';
import { TTitle } from './types';

const Title3 = ({ as = 'h3', ...rest }: TTitle) => <TitleBase {...rest} as={as} kind="title-3" />;

export default Title3;
